import { render, staticRenderFns } from "./FamilyHelp.vue?vue&type=template&id=9d86e228&lang=pug"
import script from "./FamilyHelp.vue?vue&type=script&lang=js"
export * from "./FamilyHelp.vue?vue&type=script&lang=js"
import style0 from "./FamilyHelp.vue?vue&type=style&index=0&id=9d86e228&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VCarousel,VCarouselItem,VDivider,VList,VListItem,VListItemContent})
